import { type } from '@app/store/util';
import { Action } from '@ngrx/store';

export const CLEAR_CLAIMS_STORE = type('[claims] clear claims store');

export class ClearClaimsStore implements Action {
    public type: string = CLEAR_CLAIMS_STORE;
}
